export default "__VITE_ASSET__D3oMzD3D__"